<template>
  <div>
    <div class="flex flex-row h-10 flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center ml-4 text-sm font-semibold text-grey-darkest">Lab Tests</div>
    </div>
    <!--core main-->
    <div class="flex-no-shrink flex-no-grow flex-col bg-white py-4">
        <div class="h-8 flex flex-row rounded-sm mx-2">
          <div class="w-1/2 text-sm border-r border-grey-lightest border-solid p-2 font-semibold text-grey-dark">TEST LIST</div>
          <div class="w-1/2 flex flex-row justify-between">
            <div class="text-sm self-center pl-4 font-semibold text-grey-dark">SELECTED TESTS</div>
            <diV class="pt-1 text-xs text-grey-darker font-light self-center pr-2">Total Selected : <span class="text-grey-darkest font-semibold"> {{selectedTests.length}} </span></diV>
          </div>
        </div>
        <div class="flex flex-row mx-2 flex-no-shrink flex-no-grow" style="height: calc(100vh - 11.6rem)">
            <div class="flex flex-col w-1/2 pl-2 flex-no-shrink flex-no-grow border-r border-solid border-grey-lightest">
                <input v-model="searchTerm" class="flex my-3 mb-4 px-2 h-8 mr-2 text-sm border border-grey-lightest border-solid bg-grey-extralight rounded-sm flex-no-shrink flex-no-grow" type="search" name="test_list" placeholder="Search for a test" style="width: 96%">
                <div class="overflow-y-auto pr-2" style="height: inherit">

                    <div class="text-sm font-semibold text-grey-darker mb-2" style="text-transform: uppercase">Recommended Packages</div>
                    <div class="flex text-sm my-4 cursor-pointer" @click="addSponsoredTests(test);" v-for="(test, idx) in sponsoredTests" :key="'freq'+idx" >
                      <!-- <input type="checkbox" name="test" @change="addFreqTests(idx);">  -->
                      <span class="w-full text-m text-grey-darker">&nbsp;{{test.name}}</span> 
                      <i v-if="test.test_component_names != undefined && test.test_component_names.split(',').length > 0" id="tests_list_icon" class="fas fa-info text-grey-light text-sm cursor-pointer self-center">
                        <div class="relative">
                          <div class="absolute -mt-1">
                            <i class="fas fa-caret-up text-xl text-grey-lighte"></i>
                          </div>
                          <div class="absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lightest px-3 py-2 rounded overflow-y-auto" style="width: 200px; z-index: 10; max-height: 200px; padding: 5px">
                            <div class="text-grey-darkest text-xs font-regular" style="word-break: break-all;">
                              <div class="flex flex-col justify-start">
                                <div v-for="(name,index) in test.test_component_names.split(',')" :key="index" class="ml-1 my-1">
                                  {{name}}
                                </div>
                              </div> 
                            </div>
                          </div>
                        </div>
                      </i>
                      <img class="h-3 w-1/6 self-center opacity-75" style='float: right;' src="../../assets/forward arrow.svg" alt="">
                    </div>
                  <div v-if="searchTerm.length<1">
                    <div class="text-sm font-semibold text-grey-darker mb-2" style="text-transform: uppercase">Frequently Ordered Tests </div>
                    <div class="flex text-sm my-4 cursor-pointer" @click="addFreqTests(test);" v-for="(test, idx) in freqTests" :key="'freq'+idx" >
                      <!-- <input type="checkbox" name="test" @change="addFreqTests(idx);">  -->
                      <span class="w-full text-m text-grey-darker">&nbsp;{{test.name}}</span> 
                      <i v-if="test.tests_list != undefined && test.tests_list.length > 0" id="tests_list_icon" class="fas fa-info text-grey-light text-sm cursor-pointer self-center">
                        <div class="relative">
                          <div class="absolute -mt-1">
                            <i class="fas fa-caret-up text-xl text-grey-lighte"></i>
                          </div>
                          <div class="absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lightest px-3 py-2 rounded overflow-y-auto" style="width: 200px; z-index: 10; max-height: 200px; padding: 5px">
                            <div class="text-grey-darkest text-xs font-regular" style="word-break: break-all;">
                              <div class="flex flex-col justify-start">
                                <div v-for="(name,index) in test.tests_list" :key="index" class="ml-1 my-1">
                                  {{name}}
                                </div>
                              </div> 
                            </div>
                          </div>
                        </div>
                      </i>
                      <img class="h-3 w-1/6 self-center opacity-75" style='float: right;' src="../../assets/forward arrow.svg" alt="">
                    </div>
                  </div>
                  <div class="text-sm font-semibold text-grey-darker mb-2 mt-6" style="text-transform: uppercase">Other Tests </div>
                  <div class="flex text-sm my-4 cursor-pointer" @click="addOtherTests(test);" v-for="(test, idx) in filteredList" :key="'other'+idx" >
                    <!-- <input type="checkbox" name="test" @change="addOtherTests(idx);">  -->
                    <span class="w-full text-m text-grey-darker">&nbsp;{{test.name}}</span>
                    <i v-if="test.tests_list != undefined && test.tests_list.length > 0" id="tests_list_icon" class="fas fa-info text-grey-light text-sm cursor-pointer self-center">
                      <div class="relative">
                        <div class="absolute -mt-1">
                          <i class="fas fa-caret-up text-xl text-grey-lighter"></i>
                        </div>
                        <div class="absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lightest px-3 py-2 rounded overflow-y-auto" style="width: 200px; z-index: 10; max-height: 200px; padding: 5px">
                          <div class="text-black text-xs font-regular" style="word-break: break-all;">
                            <div class="flex flex-col justify-start">
                              <div v-for="(name,index) in test.tests_list" :key="index" class="ml-1 my-1">
                                {{name}}
                              </div>
                            </div> 
                          </div>
                        </div>
                      </div>
                    </i>
                    <img class="h-3 w-1/6 self-center opacity-75" style='float: right;' src="../../assets/forward arrow.svg" alt="">
                  </div>
                </div>
            </div>
            <div class="w-1/2 pl-4 mt-4">
              <div class="flex text-sm my-4 cursor-pointer" v-for="(test, idx) in selectedTests" :key="'selected'+idx" >
                <!-- <input type="checkbox" name="test_1" @change="removeTests(idx)" checked> -->
                <span class="w-full text-m text-grey-darker">&nbsp;{{test.name}}</span>
                <img class="h-3 w-1/6 self-center opacity-75" @click="removeTests(idx)" style='float: right;' src="../../assets/close.svg" alt="">
              </div>
            </div>
        </div>
    </div>

    <!--footer-->
    <div class="fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow" v-bind:style="$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);'">
      <div class="flex flex-row mx-auto" v-if="isActiveChat != 'past'">
        <!-- <div @click="preview()" class="cursor-pointer self-center bg-blue p-2 rounded text-white font-light text-sm px-4">Preview</div> -->
        <div @click="sendToPatient()" class="cursor-pointer self-center bg-blue p-2 rounded text-white font-semibold ml-2 text-sm px-4">Send</div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/common/TextField'
import labTestsAPI from '../../api/lab_tests'
import {mapGetters} from 'vuex'
// import _ from 'lodash'
export default {
  components: {
    TextField
  },
  data () {
    return {
      searchTerm: '',
      freqTests: [
      ],
      sponsoredTests: [],
      otherTests: [],
      selectedTests: []
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      isActiveChatPresent: 'consultation/isActiveChatPresent',
      isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
      isActivePastOfflineChatPresent: 'pastOfflineConsultation/isPastChatPresent',
      activeSection: 'configuration/getActiveSection',
      activeMiniMenu: 'configuration/getActiveMiniMenu',
      storedTests: 'consultation/getLabTests',
      storedOfflineTests: 'offlineConsultation/getLabTests'
    }),
    filteredList () {
      return this.otherTests.filter(test => {
        return test.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      })
    },
    isActiveChat: function () {
      if (this.activeMiniMenu === 'OfflineConsults') {
        if (this.activeSection === 'connected' && this.isActivePastOfflineChatPresent === true) {
          return 'ongoing'
        } else if (this.activeSection === 'consults' && this.isActivePastOfflineChatPresent === true) {
          return 'past'
        }
      } else {
        if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
          return 'ongoing'
        } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
          return 'past'
        }
      }
    }
  },
  watch: {
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedTests = []
      } else {
        this.selectedTests = this.$attrs.chatType === 'online' ? this.storedTests : this.storedOfflineTests
      }
    }
  },
  created () {
    this.selectedTests = this.$attrs.chatType === 'online' ? this.storedTests : this.storedOfflineTests
  },
  mounted () {
    this.fetchLabPackages()
  },
  methods: {
    addFreqTests: function (test) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      if (this.isActiveChat !== 'past') {
        let lab = this.selectedTests.find(function (obj) {
          return (obj.id === test.id)
        })
        if (!lab) {
          test.type = 'frequentlyOrdered'
          this.selectedTests.push(test)
          let index = this.freqTests.indexOf(test)
          if (this.$attrs.chatType === 'online') {
            this.$store.dispatch('consultation/storeLabTests', {tests: this.selectedTests, customerId: this.customer.customerId})
          } else {
            this.$store.dispatch('offlineConsultation/storeLabTests', {tests: this.selectedTests, customerId: this.customer.customerId})
          }
          if (index > -1) {
            this.freqTests.splice(index, 1)
          }
        }
      } else {
        this.$toast.open({
          message: 'Cannot add tests to past consultation',
          type: 'warning',
          position: 'top',
          queue: false
        })
      }
    },
    addSponsoredTests: function (test) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      if (this.isActiveChat !== 'past') {
        let lab = this.selectedTests.find(function (obj) {
          return (obj.id === test.id)
        })
        if (!lab) {
          test.type = 'sponsored'
          this.selectedTests.push(test)
          let index = this.sponsoredTests.indexOf(test)
          if (this.$attrs.chatType === 'online') {
            this.$store.dispatch('consultation/storeLabTests', {tests: this.selectedTests, customerId: this.customer.customerId})
          } else {
            this.$store.dispatch('offlineConsultation/storeLabTests', {tests: this.selectedTests, customerId: this.customer.customerId})
          }
          if (index > -1) {
            this.sponsoredTests.splice(index, 1)
          }
        }
      } else {
        this.$toast.open({
          message: 'Cannot add tests to past consultation',
          type: 'warning',
          position: 'top',
          queue: false
        })
      }
    },
    addOtherTests: function (test) {
      if (!this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Please add chief complaint to create consultation before prescribing',
          type: 'warning',
          position: 'top',
          queue: false
        })
        return
      }
      if (this.isActiveChat !== 'past') {
        let lab = this.selectedTests.find(function (obj) {
          return (obj.id === test.id)
        })
        if (!lab) {
          let testObj = {
            id: test.id,
            name: test.name,
            number_of_tests: test.number_of_tests,
            tests_list: test.tests_list
          }
          testObj.type = 'other'
          this.selectedTests.push(testObj)
          let index = this.otherTests.indexOf(test)
          if (this.$attrs.chatType === 'online') {
            this.$store.dispatch('consultation/storeLabTests', {tests: this.selectedTests, customerId: this.customer.customerId})
          } else {
            this.$store.dispatch('offlineConsultation/storeLabTests', {tests: this.selectedTests, customerId: this.customer.customerId})
          }
          if (index > -1) {
            this.otherTests.splice(index, 1)
          }
        }
      } else {
        this.$toast.open({
          message: 'Cannot add tests to past consultation',
          type: 'warning',
          position: 'top',
          queue: false
        })
      }
    },
    removeTests: function (index) {
      let test = this.selectedTests[index]
      let listIndex = test.index
      if (test.type === 'other') {
        delete test.type
        this.otherTests.splice(listIndex, 0, test)
      } else if (test.type === 'frequentlyOrdered') {
        delete test.type
        this.freqTests.splice(listIndex, 0, test)
      } else {
        delete test.type
        this.sponsoredTests.splice(listIndex, 0, test)
      }
      this.selectedTests.splice(index, 1)
    },
    fetchLabPackages: function () {
      labTestsAPI.getPackages(this.customer.customerId).then(response => {
        if (response.status === 200) {
          this.otherTests = response.body.packages.map((test, idx) => {
            test.index = idx
            return test
          })
          this.freqTests = response.body.frequently_ordered_packages.map((test, idx) => {
            test.index = idx
            return test
          })
          this.sponsoredTests = response.body.sponsored_packages.filter(test => !test.availed_package).map((test, idx) => {
            test.index = idx
            return test
          })
        } else {

        }
      }, response => {
      }).catch(function (e) {
        console.log(e)
      })
    },
    sendToPatient: function () {
      if (this.selectedTests.length === 0) {
        alert('Please select atleast 1 test')
      } else {
        let pids = this.selectedTests.map(function (tests) { return tests.id })
        // let pnames = this.selectedTests.map(function (tests) { return tests.name })
        let recommendedTests = this.selectedTests.map((test) => {
          return {id: test.id, name: test.name, number_of_tests: test.number_of_tests, package_id: test.id}
        })
        let data = {
          customer_id: this.customer.customerId,
          consultation_id: this.customer.consultation.consultationId,
          recommended_tests: recommendedTests,
          package_ids: pids
        }
        this.$store.dispatch('message/sendRecommendedTests', {data: data, consultationType: this.activeMiniMenu})
        this.selectedTests = []
        if (this.$attrs === 'online') {
          this.$store.dispatch('consultation/storeLabTests', {tests: [], customerId: this.customer.customerId})
        } else {
          this.$store.dispatch('offlineConsultation/storeLabTests', {tests: [], customerId: this.customer.customerId})
        }
      }
    }
  }
}
</script>

<style>
#tests_list_icon > div{
    display: none;
}
#tests_list_icon:hover > div{
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/OrderLabs.vue